import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import successImage from '../assets/images/success-icon.gif';
import { toast } from 'react-toastify';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [orderDetails, setOrderDetails] = useState(null);
  const orderId = searchParams.get('orderId');
  const token = localStorage.getItem('token');

  useEffect(() => {
    localStorage.removeItem('guestAddresses');
    localStorage.removeItem('guestUser');
    localStorage.removeItem('guestOrders');
    localStorage.removeItem('guestCart');
    localStorage.removeItem('cartItems');
    localStorage.removeItem('cartTotalAmount');
    localStorage.removeItem('cartDiscountedAmount');
  }, []);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/orders/${orderId}`,
          { 
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data.success) {
          setOrderDetails(data.responseObject);
        }
      } catch (error) {
        console.error('Error fetching order details:', error);
        toast.error('Failed to fetch order details');
      }
    };

    if (orderId) {
      fetchOrderDetails();
    }
  }, [orderId, token]);

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body text-center p-5">
              <img
                src={successImage}
                alt="Payment Success"
                className="mt-4"
                style={{ width: '300px' }}
              />
              <h2 className="text-success mb-4">Payment Successful!</h2>
              {orderDetails && (
                <div className="mb-4">
                  <h5>Order ID: {orderDetails._id}</h5>
                  <p className="text-muted mb-0">
                    Amount Paid: ₹{orderDetails.finalAmount.toFixed(2)}
                  </p>
                </div>
              )}
              <p className="text-muted">
                Thank you for your purchase. Your order has been successfully placed.
              </p>
              <div className="mt-4">
                <Link to="/myorder" className="btn btn-primary me-2">
                  View Orders
                </Link>
                <Link to="/" className="btn btn-outline-primary">
                  Continue Shopping
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess; 